import React from "react";
import iconColocation from "../../images/icons/icon-colocation.svg";
import Section from "../../components/ui/Section";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import ServiceAddedValueSection from "../../components/ui/PageSections/ServiceAddedValueSection";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import ServiceKeyFeaturesSection from "../../components/ui/PageSections/ServiceKeyFeaturesSection";
import imageColocation from "../../images/image-colocation.png";
import { navigate } from "gatsby";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";
import InputTableColocation from "../../components/ui/InputTables/InputTableColocation";

const ColocationPageTemplate = ({ pageContext, translations }) => {
	return (
		<div className="flex flex-col" id="ColocationInputSection">
			<PageHeroSection
				heroIcon={iconColocation}
				heroIconAltText="White rombus rack icon"
				intro={translations["ColocationIntro"]}
				heroTitle={
					translations["ColocationMainTitle"] ? translations["ColocationMainTitle"] : pageContext.h1Title
				}
				subtitle={translations["ColocationSubtitle"] ? translations["ColocationSubtitle"] : pageContext.h2Title}
			/>
			<InputTableColocation
				serviceType="colocation"
				translations={translations}
				defaultIataCode={pageContext.iataCode}
				featureList={["Certified Data Centers", "Close to International Airports", "Fast Provisioning"]}
				pageContext={pageContext}
			/>
			{translations && (
				<Section skewed="bottom">
					<div className="w-full flex flex-col xl:flex-row xl:gap-0">
						<div className="relative container w-full xl:w-2/5">
							<ServiceAddedValueSection
								secondaryTitle="ColocationAddedValueSmallTitle"
								title="ColocationAddedValueTitle"
								subTitle="ColocationAddedValueSubtitle"
								serviceTabs={[
									{
										title: "ColocationAddedValueTitleOne",
										content: "ColocationAddedValueTextOne",
									},
									{
										title: "ColocationAddedValueTitleTwo",
										content: "ColocationAddedValueTextTwo",
									},
									{
										title: "ColocationAddedValueTitleThree",
										content: "ColocationAddedValueTextThree",
									},
									{
										title: "ColocationAddedValueTitleFour",
										content: "ColocationAddedValueTextFour",
									},
								]}
								translations={translations}
							/>
						</div>
						<div className="bg-gray-100 shadow p-6 py-10 md:p-8 rounded-lg md:w-1/3 xl:w-3/5 max-w-[400px] m-auto h-fit mt-16 xl:mt-0">
							<span className="border-2 cursor-default relative text-xs font-bold inline-flex items-start rounded-md py-0.5 px-2 z-0 border-black text-black">
								{translations["ColocationGreyBoxLabel"]}
							</span>
							<p className="my-8 text-sm text-ipxon-medium-dark-gray">
								{translations["ColocationGreyBoxTextOne"]}
							</p>
							<p className="my-8 text-sm text-ipxon-medium-dark-gray">
								{translations["ColocationGreyBoxTextTwo"]}
							</p>
							<img src={imageColocation} className="max-h-[200px] m-auto" alt="Colocation Server" />
						</div>
					</div>
				</Section>
			)}
			<Section color="transparent">
				<ServiceKeyFeaturesSection
					title={translations["ColocationKeyCharSmallTitle"]}
					subtitle={translations["ColocationKeyCharTitle"]}
					characteristicsList={[
						{
							title: translations["ColocationKeyCharOneTitle"],
							text: translations["ColocationKeyCharOneText"],
						},
						{
							title: translations["ColocationKeyCharTwoTitle"],
							text: translations["ColocationKeyCharTwoText"],
						},
						{
							title: translations["ColocationKeyCharThreeTitle"],
							text: translations["ColocationKeyCharThreeText"],
						},
						{
							title: translations["ColocationKeyCharFourTitle"],
							text: translations["ColocationKeyCharFourText"],
						},
						{
							title: translations["ColocationKeyCharFiveTitle"],
							text: translations["ColocationKeyCharFiveText"],
						},
					]}
					buttonText={translations["ColocationKeyCharButtonText"]}
					onClickHandler={() => {
						navigate("#ColocationInputSection");
					}}
				/>
				<EmpowerServicesSection translations={translations} />
			</Section>
			<Section>
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["ColocationContactUsBannerTitle"]}
					subtitle={translations["ColocationContactUsBannerText"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default ColocationPageTemplate;
